// @ts-nocheck


import queryString from 'query-string';





import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (
licensePlateChange) => (
{
  ...licensePlateChange,
  paymentAmount: convertFromKopToRub(licensePlateChange.paymentAmount),
  act: licensePlateChange.act ?
  actConvertDataFromServer(licensePlateChange.act) :
  undefined
});

export const convertDataToServer = (
licensePlateChange) => (
{
  ...licensePlateChange,
  paymentAmount: convertFromRubToKop(licensePlateChange.paymentAmount)
});

export const addLicensePlateChange = async (
licensePlateChange) =>
{
  const added = await fetchRequest.post(
    '/licensePlateChange',
    convertDataToServer(licensePlateChange)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать замену гос. номера');
};

export const updateLicensePlateChange = async (
licensePlateChange) =>
{
  const updated = await fetchRequest.put(
    '/licensePlateChange',
    convertDataToServer(licensePlateChange)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить замену гос. номера');
};
export const deleteLicensePlateChange = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/licensePlateChange/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить замену гос. номера');
};

export const fetchLicensePlateChange = async (
id,
params = {}) =>
{
  const licensePlateChange = await fetchRequest.get(
    `/licensePlateChange/${id}`,
    params
  );
  if (licensePlateChange) return convertDataFromServer(licensePlateChange);
  throw new Error('Не удалось получить замену гос. номера');
};

export const fetchVehicleLicensePlateChanges = async (
vehicleId,
params = initialFetchListParams) =>
{
  const licensePlateChangees = await fetchRequest.get(
    `/licensePlateChange/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (licensePlateChangees) {
    return {
      ...licensePlateChangees,
      data: licensePlateChangees.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список замен гос. номеров');
};

export const fetchLicensePlateChanges = async (
params = initialFetchListParams) =>
{
  const licensePlateChanges = await fetchRequest.get(`/licensePlateChange`, {
    ...initialFetchListParams,
    ...params
  });
  if (licensePlateChanges) {
    return {
      ...licensePlateChanges,
      data: licensePlateChanges.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список замен гос. номеров');
};

export const updateAct = async (
params,
data) =>
{
  const licensePlateChange = await fetchRequest.put(
    `/licensePlateChange/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (licensePlateChange) {
    return {
      ...licensePlateChange,
      data: licensePlateChange.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось закрепить акт за списоком замен гос. номеров');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/licensePlateChange/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/licensePlateChange/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/licensePlateChange/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  getTotalSum,
  updateAct,
  addLicensePlateChange,
  updateLicensePlateChange,
  deleteLicensePlateChange,
  fetchLicensePlateChange,
  fetchVehicleLicensePlateChanges,
  fetchLicensePlateChanges,
  printReport
};
